import { createStore } from "vuex";

// Other Stores
import login from "./login";
import dashboard from "./dashboard";
import applications from "./applications";
import customers from "./customers";

export default createStore({
  modules: {
    login,
    dashboard,
    applications,
    customers,
  },
});
